export const DEFAULT_SCALE_ID = 'default';
export const DEFAULT_LANGUAGE = 'EN';

export const DEFAULT_SCALE = {
  value: DEFAULT_SCALE_ID,
  label: 'Default',
};
